import { useState } from "react";

import { toast } from "sonner";

import { Button } from "../../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useApi } from "../../context/ApiContext";
import { useAuth } from "../../context/AuthContext";

const LoginPage = () => {
  const { login } = useAuth();
  const api = useApi();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const result = await login(credentials.email, credentials.password);

    if (!result.success) {
      setError(result.error);
    }
    setLoading(false);
  };

  const initializeSystem = async () => {
    try {
      const response = await api.post(`/init`);
      toast.success("System initialized! You can now login with admin@brikflow.com / admin123");
    } catch (error) {
      console.error("Initialize system error:", error);
      if (error.code === "NETWORK_ERROR" || error.message === "Network Error") {
        toast.error("Cannot connect to server. Please check if the backend is running.");
      } else {
        toast.error(error.message || "Failed to initialize system");
      }
    }
  };

  return (
    <div className="app-container min-h-screen bg-gradient-to-br from-yale-blue-900 to-yale-blue-700 flex items-center justify-center p-4">
      <Card className="w-full max-w-md mobile-safe-content">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img
              src="/images/brikflow_logo_login-removebg-preview.png"
              alt="BrikFlow Logo"
              className="h-20 w-auto object-contain"
            />
          </div>

          <CardDescription>Construction Site Tracking System</CardDescription>
        </CardHeader>
        <CardContent>
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                placeholder="Enter your email"
                className="mobile-text"
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="Enter your password"
                className="mobile-text"
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-primary hover:bg-yale-blue-600 min-h-[48px] text-base font-medium"
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
